import { AxiosResponse } from 'axios'
import { http } from '../realisations/Http.realisation'
import {
    AdditionalServicesTypesList,
    UpdateAdditionalServicesPayloadT,
} from '../types/additional_services.types'

export class AdditionalServicesRepository {
    getList(): Promise<AxiosResponse<AdditionalServicesTypesList>> {
        return http.get('/cabinet/api/v2/additional-service-types')
    }

    updateInvoiceAdditionalServices(
        invoice_id: number,
        payload: UpdateAdditionalServicesPayloadT
    ): Promise<AxiosResponse<void>> {
        return http.put(`/cabinet/api/v2/additional-services/${invoice_id}/invoice`, payload)
    }

    updateOrderAdditionalServices(
        order_id: number,
        payload: UpdateAdditionalServicesPayloadT
    ): Promise<AxiosResponse<void>> {
        return http.put(`/cabinet/api/v2/additional-services/${order_id}/order`, payload)
    }
}
